<template>
  <vx-card class="mt-2 pagebreak-inside-avoid">
    <table class="table table-bordered">
      <tr class="title p-1 w-full">
        <th colspan="2">QUESTIONÁRIO DE AVALIAÇÃO DE RISCO</th>
      </tr>
      <tr v-for="(item, index) in proposalData.agravos" :key="index">
        <td class="pl-3">{{ getRiskQuestionLabel(item) }}</td>
        <td class="pl-3">{{ getRiskQuestionAnswer(item) }}</td>
      </tr>
    </table>
    <div
      v-if="customSectionsMsgs.RISK_QUESTIONNAIRE"
      style="text-align: justify"
      class="pl-3 pt-3"
      v-html="customSectionsMsgs.RISK_QUESTIONNAIRE"
    ></div>
  </vx-card>
</template>

<script>
export default {
  name: 'EndorsementContractIncreases',
  props: {
    proposalData: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    customSectionsMsgs: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      getRiskQuestionLabel(item) {
        const [pergunta] = Object.keys(item);
        return pergunta;
      },
      getRiskQuestionAnswer(item) {
        const [resposta] = Object.values(item);
        return resposta.resposta;
      },
    };
  },
};
</script>
